<template>
  <el-tabs
    v-if="detailList.length"
    v-model="activeIndex"
    type="border-card"
    closable
    @tab-remove="handleRemove"
  >
    <el-tab-pane
      v-for="(item, index) in detailList"
      :key="item.id"
      :label="item.authProductLabel"
      :name="`${index + 1}`"
    >
      <copyright-detail-item :item="detailList[index]"></copyright-detail-item>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import CopyrightDetailItem from './CopyrightDetailItem.vue'
export default {
  name: 'CopyrightDetailList',
  components: {
    CopyrightDetailItem
  },
  props: {
    detailList: {
      type: Array,
      default: () => []
    },
    current: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      activeIndex: '1'
    }
  },
  watch: {
    current(newVal) {
      this.activeIndex = String(newVal)
    }
  },
  methods: {
    handleRemove(name) {
      this.$emit('remove', Number(name) - 1)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
